import MapLine from "../../components/MapLine";

export default function MapLinePage() {
    return (
        <MapLine/>
    )
};